export default __webpack_public_path__ + "static/media/bch.334d36bd.svg";